import { AfterViewChecked, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core'
import { Image, Parking, parkingsPath, ParkingStatus, TrackingEntryType } from '@parkupp/core'
import { Router } from '@angular/router'
import { ParkingService } from '../../../services/parking.service'
import { CarouselConfig } from 'ngx-bootstrap/carousel'
import { SortImagesByDatePipe } from '../../core/pipes/sort-images-by-date.pipe'
import { SortImagesByPrimaryImagePipe } from '../../core/pipes/sort-images-by-primary-image.pipe'
import { TrackingService } from '../../../services/tracking.service'
import { doc } from '@angular/fire/firestore'
import { InViewportDirective } from '../../core/directives/inViewport.directive'
import { AuthenticationService } from '../../../services/authentication.service'

@Component({
    selector: 'app-parking-list-item-bookup',
    templateUrl: './parking-list-item-bookup.component.html',
    styleUrls: ['./parking-list-item-bookup.component.scss'],
})
export class ParkingListItemBookupComponent implements OnInit {
    @Input() parking: Parking
    @Input() merchantKey: string
    @Input() forMerchants = false
    @Input() highlighted: boolean
    @Output() onSelect = new EventEmitter<Parking>()
    @Output() onHover = new EventEmitter<Parking | null>()
    @ViewChild(InViewportDirective) inViewportDirective: InViewportDirective

    images: Image[] = []
    loading = false
    error: string
    emitEvent = true
    firstSlide = true
    highestIndex = 0
    parkingStatus = ParkingStatus

    alreadyTracked = false

    constructor(private router: Router, private parkingService: ParkingService, private trackingService: TrackingService, private authenticationService: AuthenticationService) {}

    ngOnInit(): void {
        if (this.parking.images) {
            for (const key in this.parking.images) {
                this.images.push(this.parking.images[key])
            }
            this.images = SortImagesByDatePipe.sortImages(this.images)
            this.images = SortImagesByPrimaryImagePipe.sortImages(this.images, this.parking.imagePrimary ? this.parking.imagePrimary : '')
        }
    }

    activeSlideChange(index: number) {
        if (index > this.highestIndex) {
            this.highestIndex = index
        }
        if (!this.firstSlide) {
            this.emitEvent = false
        }
        this.firstSlide = false
    }
}
